export type InquiryStatus =
  | "new"
  | "contacted"
  | "pending"
  | "converted"
  | "rejected"
  | "archived"
  | string;

export type BookingInquiryListItem = {
  id: number;
  property_id?: number | null;
  property_title?: string | null;
  property_slug?: string | null;
  property_url?: string | null;

  check_in?: string | null;
  check_out?: string | null;
  guests_total?: number | null;

  arrival_time?: string | null;
  pets?: boolean | null;

  full_name?: string | null;
  email?: string | null;
  phone?: string | null;

  message?: string | null;
  status?: InquiryStatus | null;
  internal_notes?: string | null;

  locale?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type BookingInquiryDetails = BookingInquiryListItem;

export type PagedResponse<T> = {
  ok?: boolean;
  items?: T[];
  total?: number;
  hasMore?: boolean;
  error?: string;
};

export const DEFAULT_INQUIRY_STATUSES: { value: string; label: string }[] = [
  { value: "", label: "All statuses" },
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "pending", label: "Pending" },
  { value: "converted", label: "Converted" },
  { value: "rejected", label: "Rejected" },
  { value: "archived", label: "Archived" },
];

export function safeStr(v: any, fallback = ""): string {
  if (v === null || v === undefined) return fallback;
  const s = String(v);
  return s === "null" || s === "undefined" ? fallback : s;
}

export function fmtDate(d?: string | null): string {
  const s = safeStr(d, "");
  if (!s) return "—";
  return s;
}

export function nightsBetween(checkIn?: string | null, checkOut?: string | null): number | null {
  const a = safeStr(checkIn, "");
  const b = safeStr(checkOut, "");
  if (!a || !b) return null;
  const da = new Date(a + "T00:00:00");
  const db = new Date(b + "T00:00:00");
  const ms = db.getTime() - da.getTime();
  if (!Number.isFinite(ms)) return null;
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

export function fmtDateRange(checkIn?: string | null, checkOut?: string | null): string {
  const a = fmtDate(checkIn);
  const b = fmtDate(checkOut);
  if (a === "—" && b === "—") return "—";
  return `${a} → ${b}`;
}
